// @ts-ignore
import Card from "components/Card/Card.jsx";
// @ts-ignore
import CardBody from "components/Card/CardBody.jsx";
// @ts-ignore
import Button from "components/CustomButtons/Button.jsx";
// @ts-ignore
import GridContainer from "components/Grid/GridContainer.jsx";
// @ts-ignore
import GridItem from "components/Grid/GridItem.jsx";
// @ts-ignore
import { Proxy, withArtifex } from "core";
// @ts-ignore
import ClientHelper from "core/ClientHelper";
// @ts-ignore
import DateHelper from "core/DateHelper";
import PropTypes, { array, bool } from "prop-types";
import React from "react";
// @ts-ignore
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
// @ts-ignore
import {
   GenericAlert,
   GenericPage,
   GenericCheckInput,
   GenericExpansionPanel,
   GenericTextInput,
   GenericSelectInput,
} from "views/Components/Generic";
// @ts-ignore
import LoadingComponent from "views/Components/LoadingComponent";
// @ts-ignore
import { Portals, ProgramCodes } from "views/Constants/Constant";
import OrderingClientDetail from "views/WireTransfer/CreateIncomingWireTransfer/OrderingClientDetail.jsx";
import OrderingAmountDetail from "views/WireTransfer/CreateIncomingWireTransfer/OrderingAmountDetail.jsx";

import StringHelper from "core/StringHelper.js";

class CreatreIncomingWireTransfersCS extends GenericPage {
   constructor(props) {
      super(props);
      this.getappCenterTitle = "Empty";
      this.getappLeftTitle = "Empty";
      this.IsBackOffice = ClientHelper.IsBackOffice();
      this.defaultBeneficiaryModel = {
         IsCorporate: false,
         LegalName: "",
         AddressLine1: "",
         AddressLine2: "",
         ZipCode: "",
         CityName: "",
         ProvinceName: "",
         CountryName: "",
         Accounts: [],
         EntityType: "",
         IdentifierType: "",
         DocumentNumber: "",
         ProvinceOfRegistration: "",
         CountryOfRegistration: "",
      };

      this.defaultModel = {
         UniqueClientId: null,
         AccountNumber: null,
         Amount: 0,
         CurrencyId: 26,
         WireTransactionDate: DateHelper.GetDateTime(),
         WirePurpose: null,
         WireReferenceNumber: null,
         WireIncomingBeneficiaryId: null,
         OrderingClientName: null,
         OrderingCountryId: null,
         OrderingProvinceId: null,
         OrderingCityId: null,
         OrderingAddressLine1: null,
         OrderingAddressLine2: null,
         OrderingZipCode: null,
         OrderingSourceAccountNumber: null,
         InternationalBankCountryId: null,
         SendingFI: null,
         SendingFISwiftCode: null,
         SendingFICountryId: null,
         SendingFIAddress: null,
         IsDomestic: null,
      };

      this.MaxLen = { maxLength: 30 };
      this.SortedCountry = { Member: "OrderIndex" };

      this.defaultClientModel = {
         Id: null,
         Name: null,
         UniqueClientId: null,
         OrganizationUniqueId: null,
      };

      this.defaultReceiverModel = {
         Id: null,
         Name: null,
         Address1: null,
         Address2: null,
         City: null,
         Province: null,
         Country: null,
         PostalCode: null,
         AccountNumber: null,
         SWIFT: null,
         FI: null,
         FITransitNum: null,
         FIAddress1: null,
         FIAddress2: null,
         FICity: null,
         FIProvince: null,
         FICountry: null,
         FIPostalCode: null,
      };

      this.defaultStatusModel = {
         IsClearDialogOpen: false,
         SaveConfirmDialog: false,
         IsSubmitTemplate: false,
         Alert: null,
         AcceptTerms: false,
         AmountPrefix: "$",
      };

      this.AcceptTermText =
         "I do confirm my rights to bind the company and have the authority to perform the transaction on behalf of the company.";

      this.state = {
         Model: { ...this.defaultModel },
         StatusModel: { ...this.defaultStatusModel },
         BeneficiaryInfo: { ...this.defaultBeneficiaryModel },
         ReceiverModel: { ...this.defaultReceiverModel },
         ReceiverInfo: [],
         ClientInfo: [],
         isLoading: false,
      };
   }

   async componentDidMount() {
      try {
         super.componentDidMount();
         const { setAppLeftTitle, setAppCenterTitle, setPortal } = this.props;

         if (setAppLeftTitle) {
            setAppLeftTitle("Create Incoming Wire Transfer");
            this.getappLeftTitle = "Create Incoming Wire Transfer";
         }
         if (setAppCenterTitle) {
            setAppCenterTitle("WIRE TRANSFER");
            this.getappCenterTitle = "WIRE TRANSFER";
         }
         if (setPortal) {
            setPortal(Portals.WireTransfer);
         }
         await this.ClientsInfo();
      } catch (error) {
         console.error("Error in componentDidMount:", error);
      }
   }

   async ClientsInfo(continueWith = null) {
      this.ExecutePostRequest("/bankapi/v1.0/WireTransfer/GetWireClients", {}, (responseData) => {
         this.setState({ ClientInfo: responseData.Item }, continueWith);
      });
   }

   BeneficiaryInfo(Id, continueWith = null) {
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/SearchIncomingWireBeneficiaryAccounts",
         { Id },
         (responseData) => {
            this.setState({ BeneficiaryInfo: { ...responseData.Item } }, continueWith);
         }
      );
   }

   ReceiverInfo(Id, continueWith = null) {
      this.ExecutePostRequest("/bankapi/v1.0/WireTransfer/SearchIncomingWireReceiverInfo", { Id }, (responseData) => {
         this.setState({ ReceiverInfo: responseData.Item }, continueWith);
      });
   }

   GetRenderItemAccount = (x) => {
      this.renderItemAccount = `${x.AccountNumber} - ${x.AccountName}`;
      return this.renderItemAccount;
   };

   OnlyLetterAndDigit = (str) => StringHelper.VerifiyDigitAndLetterForWire(str);

   VerifiyLine = (str) => StringHelper.VerifiyWireLine(str);

   ClearBenefReceivInfo(isCompletelyClear) {
      const { Model } = this.state;
      if (isCompletelyClear === true) {
         Model.UniqueClientId = null;
      }
      Model.WireIncomingBeneficiaryId = null;

      this.setState({
         BeneficiaryInfo: { ...this.defaultBeneficiaryModel },
         ReceiverModel: { ...this.defaultReceiverModel },
         ReceiverInfo: [],
         Model,
      });
   }

   ClearReceivInfo() {
      const { Model } = this.state;
      Model.WireIncomingBeneficiaryId = null;

      this.setState({
         ReceiverModel: { ...this.defaultReceiverModel },
         ReceiverInfo: [],
         Model,
      });
   }

   ValueChanged(name, newValue, data) {
      this.setState((prevState) => {
         const { Model } = this.state;
         const updatedOrderingModel = { ...prevState.OrderingModel, [name]: newValue };
         const updatedStatusModel = { ...prevState.StatusModel, [name]: newValue };
         let updatedReceiverModel = { ...prevState.ReceiverModel };
         Model[name] = newValue;

         if (name === "UniqueClientId" && data && data.Id !== null) {
            this.ClearBenefReceivInfo(false);
            Model.UniqueClientId = newValue;
            Model.AccountNumber = null;
            this.BeneficiaryInfo(data.Id);
            this.ReceiverInfo(data.OrganizationUniqueId);
         }

         if (name === "UniqueClientId" && newValue === null) {
            this.ClearBenefReceivInfo(true);
         }

         if (name === "WireIncomingBeneficiaryId" && data != null) {
            updatedReceiverModel = {
               ...updatedReceiverModel,
               Name: data.ReceiverName,
               Address1: data.ReceiverAddress1,
               Address2: data.ReceiverAddress2,
               City: data.ReceiverCity,
               Province: data.ReceiverProvince,
               Country: data.ReceiverCountry,
               PostalCode: data.ReceiverPostalCode,
               AccountNumber: data.ReceiverAccountNumber,
               SWIFT: data.ReceiverSWIFT,
               FI: data.ReceiverFI,
               FITransitNum: data.ReceiverFITransitNumber,
               FIAddress1: data.ReceiverFIAddress1,
               FIAddress2: data.ReceiverFIAddress2,
               FICity: data.ReceiverFICity,
               FIProvince: data.ReceiverFIProvince,
               FICountry: data.ReceiverFICountry,
               FIPostalCode: data.ReceiverFIPostalCode,
            };
         }

         if (name === "CurrencyId" && this.defaultModel.CurrencyId == null) {
            Model.CurrencyId = newValue;
         }

         const validationFields = ["SendingFISwiftCode"];
         if (validationFields.includes(name) && newValue) {
            const isValid =
               name === "SendingFISwiftCode" ? this.OnlyLetterAndDigit(newValue) : this.VerifiyLine(newValue);
            if (isValid) {
               return true;
            }
         }

         if (name === "OrderingCountryId") {
            Model.OrderingProvinceId = null;
            Model.OrderingCityId = null;
         }

         if (name === "SendingFICountryId") {
				if (data?.ISO2 == "CA") {
					Model.IsDomestic = true;
				} else {
					Model.IsDomestic = false;
				}
			}

			console.log(Model.IsDomestic)
         return {
            Model,
            StatusModel: updatedStatusModel,
            ReceiverModel: updatedReceiverModel,
            OrderingModel: updatedOrderingModel,
         };
      });
   }

   HandleCreateOrUpdate() {
      const { Model } = this.state;

      this.setState({ isLoading: true });

      const request = { ...Model };

      Proxy.POST(
         "/bankapi/v1.0/WireTransfer/CreateOrUpdateWireTransferIncomingDetail",
         request,
         (createResponseData) => {
            this.setState({ isLoading: false });

            if (!createResponseData.IsSucceeded) {
               this.ShowGenericMessage("error", "Error", createResponseData.ErrorDescription);
               return;
            }

            if (createResponseData.ErrorCode != "0") {
               this.ShowGenericMessage("error", "Rejected", createResponseData.ErrorDescription);
               return;
            }

            this.ShowGenericMessage("success", "Create", "Created successfully.");

            this.ClearScreen();
         }
      );
   }

   ShowConfirmMessage() {
      if (!this.Validate()) return;

      this.setState({
         Alert: (
            <GenericAlert
               Title="Caution"
               Message="After confirming the operation, you will not be able to modify the record manually. Please ensure your data is correct."
               Type="warning"
               ShowCancel={true}
               OnCancel={() => this.HideAlert()}
               OnConfirm={() => this.HandleCreateOrUpdate()}
            />
         ),
      });
   }

   ShowClearMessage() {
      this.setState({
         Alert: (
            <GenericAlert
               Title="Clear Screen"
               Message="This will erase all the information you have entered on this screen. Are you sure you want to cancel this transaction?"
               Type="info"
               ShowCancel={true}
               OnCancel={this.HideAlert}
               OnConfirm={this.HandleClearConfirm}
            />
         ),
      });
   }

   HandleClearConfirm() {
      this.ClearScreen();
      this.HideAlert();
   }

   ClearScreen() {
      const { StatusModel } = this.state;
      StatusModel.IsClearDialogOpen = false;
      this.setState({
         Model: { ...this.defaultModel },
         StatusModel: { ...this.defaultStatusModel },
         BeneficiaryInfo: { ...this.defaultBeneficiaryModel },
         ReceiverModel: { ...this.defaultReceiverModel },
      });
   }

   Validate() {
      const { Model, StatusModel } = this.state;
      var messages = [];

      if (StatusModel.AcceptTerms == false) {
         this.ShowGenericMessage("warning", "Warning", "Please accept the confirmation message and then try again.");
         return false;
      }
		if (!Model.UniqueClientId) messages.push("Beneficiary client cannot be null.");
		if (!Model.WireIncomingBeneficiaryId) messages.push("Receiver cannot be null.");
      if (!Model.WireTransactionDate) messages.push("Date Request cannot be null.");
      if (!Model.Amount || Model.Amount <= 0) messages.push("Amount cannot be equal to 0 or less.");
      if (!Model.WirePurpose) messages.push("Purpose of Wire cannot be null.");
      if (!Model.AccountNumber || Model.AccountNumber < 1) messages.push("Beneficiary Account Number cannot be empty!");
      if (!Model.OrderingClientName) messages.push("Ordering Client Name cannot be null.");
      if (!Model.OrderingCountryId) messages.push("Ordering Country cannot be null.");
      if (!Model.OrderingProvinceId) messages.push("Ordering Province cannot be null.");
      if (!Model.OrderingCityId) messages.push("Ordering City cannot be null.");
      if (!Model.OrderingAddressLine1) messages.push("Address Line 1 cannot be null.");
      if (!Model.OrderingZipCode) messages.push("Postal Code cannot be null.");
      if (!Model.OrderingSourceAccountNumber) messages.push("Ordering Source Account Number cannot be null.");
      if (!Model.IsDomestic && !Model.InternationalBankCountryId) messages.push("International Bank Country cannot be null.");
      if (!Model.SendingFI) messages.push("Sending Financial Institution cannot be null.");
      if (!Model.IsDomestic && !Model.SendingFISwiftCode) messages.push("Sending FI Swift Code cannot be null.");
      if (!Model.SendingFICountryId) messages.push("Sending FI Country cannot be null.");
      if (!Model.SendingFIAddress) messages.push("Sending FI Address cannot be null.");

      if (messages.length > 0) {
         this.ShowGenericMessage(
            "warning",
            "Please fill required fields!",
            messages.map((x, i) => <div key={i}>{x}</div>)
         );
         return false;
      }

      return true;
   }

   render() {
      const { Disabled } = this.props;
      const { Alert, isLoading, IsLoading, IsBackOffice } = this.state;
      const { Model, StatusModel, BeneficiaryInfo, ReceiverInfo, ReceiverModel, ClientInfo } = this.state;
      return (
         <div>
            {Alert}
            <LoadingComponent Show={isLoading || IsLoading} />
            <ButtonToolbar
               ButtonList={[
                  {
                     Code: "Clear",
                     OnClick: this.ShowClearMessage,
                     Disabled: Disabled,
                  },
                  {
                     Code: "Submit",
                     OnClick: this.ShowConfirmMessage,
                     Disabled: Disabled,
                  },
                  // {
                  //    Code: "Delete",
                  //    OnClick: this.HandleDelete,
                  //    Disabled: true, //Template.Id == 0 ? true : false,
                  // },
                  // {
                  //    Code: "SubmitTemplate",
                  //    OnClick: this.SubmitTemplate,
                  //    Disabled: true, //Disabled,
                  // },
               ]}
               menuId={this.props.menuId}
               ApprovalData={this.props.ApprovalData}
               After={this.props.After}
            ></ButtonToolbar>
            <br />
            <Card>
               <GenericExpansionPanel Title={"Incoming Wire Transfer Transaction Entry"}>
                  <CardBody>
                     <GridContainer spacing={16}>
                        <GridItem xs={4}>
                           <GridContainer>
                              <GridItem xs={12}>
                                 <h4 style={{ color: "black" }}>
                                    <b>Beneficiary Information</b>
                                 </h4>
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericSelectInput
                                    Name="UniqueClientId"
                                    LabelText="Beneficiary Client"
                                    IsStatic
                                    StaticData={ClientInfo}
                                    KeyValueMember="Id"
                                    RenderItem={(d) => `${d.UniqueClientId} - ${d.Name}`}
                                    Value={Model.UniqueClientId || ""}
                                    ValueChanged={this.ValueChanged}
                                    Disabled={IsBackOffice}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary Client Name"
                                    Value={BeneficiaryInfo.LegalName}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericSelectInput
                                    Name="AccountNumber"
                                    LabelText="Beneficiary Account Number"
                                    Required={true}
                                    KeyValueMember="AccountNumber"
                                    IsStatic
                                    StaticData={BeneficiaryInfo.Accounts}
                                    TextValueMember="AccountNumber"
                                    RenderItem={this.GetRenderItemAccount}
                                    Value={Model.AccountNumber}
                                    ValueChanged={this.ValueChanged}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary Address Line 1"
                                    Value={BeneficiaryInfo.AddressLine1}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary Address Line 2"
                                    Value={BeneficiaryInfo.AddressLine2}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary Postal Code"
                                    Value={BeneficiaryInfo.ZipCode}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary City"
                                    Value={BeneficiaryInfo.CityName}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary Province"
                                    Value={BeneficiaryInfo.ProvinceName}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Beneficiary Country"
                                    Value={BeneficiaryInfo.CountryName}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Entity Type"
                                    Value={BeneficiaryInfo.EntityType}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Entity Identifier Type"
                                    Value={BeneficiaryInfo.IdentifierType}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Entity Document Number"
                                    Value={BeneficiaryInfo.DocumentNumber}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Entity Province Of Registration"
                                    Value={BeneficiaryInfo.ProvinceOfRegistration}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Entity Country Of Registration"
                                    Value={BeneficiaryInfo.CountryOfRegistration}
                                    Disabled={true}
                                 />
                              </GridItem>
                           </GridContainer>
                        </GridItem>
                        <GridItem xs={4}>
                           <GridContainer>
                              <GridItem xs={12}>
                                 <h4 style={{ color: "black" }}>
                                    <b>Receiver Information</b>
                                 </h4>
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericSelectInput
                                    Name="WireIncomingBeneficiaryId"
                                    LabelText="Receiver"
                                    Required={true}
                                    KeyValueMember="Id"
                                    IsStatic
                                    StaticData={ReceiverInfo}
                                    TextValueMember="Alias"
                                    Value={Model.WireIncomingBeneficiaryId}
                                    ValueChanged={this.ValueChanged}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Name"
                                    Value={ReceiverModel.Name}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Address Line 1"
                                    Value={ReceiverModel.Address1}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Address Line 2"
                                    Value={ReceiverModel.Address2}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver City"
                                    Value={ReceiverModel.City}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Province"
                                    Value={ReceiverModel.Province}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Country"
                                    Value={ReceiverModel.Country}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Postal Code"
                                    Value={ReceiverModel.PostalCode}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver Account Number"
                                    Value={ReceiverModel.AccountNumber}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver SWIFT"
                                    Value={ReceiverModel.SWIFT}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput LabelText="Receiver FI" Value={ReceiverModel.FI} Disabled={true} />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI Branch"
                                    Value={ReceiverModel.FITransitNum}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI Address 1"
                                    Value={ReceiverModel.FIAddress1}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI Address 2"
                                    Value={ReceiverModel.FIAddress2}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI City"
                                    Value={ReceiverModel.FICity}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI Province"
                                    Value={ReceiverModel.FIProvince}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI Country"
                                    Value={ReceiverModel.FICountry}
                                    Disabled={true}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    LabelText="Receiver FI Postal Code"
                                    Value={ReceiverModel.FIPostalCode}
                                    Disabled={true}
                                 />
                              </GridItem>
                           </GridContainer>
                        </GridItem>
                        <GridItem xs={4}>
                           <OrderingClientDetail
                              ValueChanged={this.ValueChanged}
                              OrderingClientName={Model.OrderingClientName}
                              InternationalBankCountryId={Model.InternationalBankCountryId}
                              SendingFI={Model.SendingFI}
                              SendingFISwiftCode={Model.SendingFISwiftCode}
                              SendingFIAddress={Model.SendingFIAddress}
                              SendingFICountryId={Model.SendingFICountryId}
                              OrderingAddressLine1={Model.OrderingAddressLine1}
                              OrderingAddressLine2={Model.OrderingAddressLine2}
                              OrderingZipCode={Model.OrderingZipCode}
                              OrderingCityId={Model.OrderingCityId}
                              OrderingProvinceId={Model.OrderingProvinceId}
                              OrderingCountryId={Model.OrderingCountryId}
                              OrderingSourceAccountNumber={Model.OrderingSourceAccountNumber}
										IsDomestic={Model.IsDomestic}
                              Disabled={false}
                           ></OrderingClientDetail>
                        </GridItem>
                        <GridItem xs={8}>
                           <Card>
                              <CardBody>
                                 <OrderingAmountDetail
                                    ValueChanged={this.ValueChanged}
                                    WirePurpose={Model.WirePurpose}
                                    WireReferenceNumber={Model.WireReferenceNumber}
                                    CurrencyId={Model.CurrencyId}
                                    Amount={Model.Amount}
                                    AmountPrefix={StatusModel.AmountPrefix}
                                    WireTransactionDate={Model.WireTransactionDate}
                                    Disabled={false}
                                 ></OrderingAmountDetail>
                              </CardBody>
                           </Card>
                        </GridItem>
                        <GridItem xs={8} style={{ textAlign: "left", alignSelf: "center" }}>
                           <GenericCheckInput
                              Name="AcceptTerms"
                              LabelText={this.AcceptTermText}
                              IsTextLeft
                              Value={StatusModel.AcceptTerms}
                              ValueChanged={this.ValueChanged}
                           />
                        </GridItem>
                     </GridContainer>
                  </CardBody>
               </GenericExpansionPanel>
            </Card>
         </div>
      );
   }
}

CreatreIncomingWireTransfersCS.propTypes = {
   classes: PropTypes.object.isRequired,
   Disabled: PropTypes.bool,
   ValueChanged: PropTypes.func,
   Model: PropTypes.object,
   ExecuteApiFileDownloadWithGenericResponse: PropTypes.func,
};

export default withArtifex(CreatreIncomingWireTransfersCS, {});